/** One row of the bv_email_intake_daily view (migration 171). Day is the UTC date. */
export type DailyIntakeRow = {
  org_id: string;
  day: string;
  // From the ingest queue; null on days synced before the queue existed.
  found: number | null;
  queue_pending: number | null;
  queue_ingested: number | null;
  queue_duplicate: number | null;
  queue_filtered: number | null;
  queue_failed: number | null;
  // From stored emails; null on days with queue rows but no stored emails.
  stored: number | null;
  assigned: number | null;
  held: number | null;
  unmatched: number | null;
  ignored: number | null;
  pdfs: number | null;
  pdfs_parsed: number | null;
  pdfs_failed: number | null;
  pdfs_in_progress: number | null;
  pdfs_waiting: number | null;
};

// ponytail: "missing" uses the queue's own accounting. Comparing found with stored per day is unreliable:
// Gmail reads date-only windows in Pacific time while stored emails group by UTC day, and duplicates are
// counted on both sides.
export function rowFlags(row: DailyIntakeRow): { missing: boolean; parseFailed: boolean } {
  return { missing: (row.queue_failed ?? 0) > 0, parseFailed: (row.pdfs_failed ?? 0) > 0 };
}
